document.querySelectorAll('.price-filter-button').forEach(function(button) {
      button.addEventListener('click', function(event) {
          var collectionId = button.getAttribute('data-collection-id');
          var buttonRect = button.getBoundingClientRect();
          var popup = document.getElementById('price-popup-' + collectionId);
          var popupContent = document.getElementById('popup-content-' + collectionId);
          popup.style.left = buttonRect.left + 'px';
          popup.style.top = buttonRect.bottom + window.scrollY + 'px'; // Add scroll position if needed
          popup.style.display = 'block'; // Show the popup
      });
  });

  document.querySelectorAll('.close-popup').forEach(function(closeButton) {
      closeButton.addEventListener('click', function(event) {
          var collectionId = closeButton.getAttribute('id').replace('close-popup-', '');
          document.getElementById('price-popup-' + collectionId).style.display = 'none';
      });
  });

  document.querySelectorAll('.size-filter-dropdown').forEach(function(selectBox) {
      selectBox.addEventListener('change', function(event) {
          var collectionId = event.target.getAttribute('data-collection-id');
          filterProducts(collectionId);
      });
  });

  document.querySelectorAll('.min-price, .max-price').forEach(function(inputBox) {
      inputBox.addEventListener('input', function(event) {
          var collectionId = event.target.getAttribute('data-collection-id');
          filterProducts(collectionId);
      });
  });

  document.querySelectorAll('.sort-filter-dropdown').forEach(function(selectBox) {
      selectBox.addEventListener('change', function(event) {
          var collectionId = event.target.getAttribute('data-collection-id');
          var sortBy = event.target.value;
          sortProducts(collectionId, sortBy);
      });
  });

  function filterProducts(collectionId) {
      var selectedSize = document.querySelector('#size-filter-' + collectionId).value;
      var minPrice = parseFloat(document.querySelector('#min-price-' + collectionId).value) || 0;
      var maxPrice = parseFloat(document.querySelector('#max-price-' + collectionId).value) || 1000000;
      var products = document.querySelectorAll('.product-item[data-collection-id="' + collectionId + '"]');

      products.forEach(function(product) {
          var productSizes = product.getAttribute('data-sizes').split(',');
          var productPrice = parseFloat(product.getAttribute('data-price'));

          var matchesSize = (selectedSize === 'all' || productSizes.includes(selectedSize));
          var matchesPrice = (productPrice >= minPrice && productPrice <= maxPrice);

          if (matchesSize && matchesPrice) {
              product.style.display = 'block'; 
          } else {
              product.style.display = 'none'; 
          }
      });
  }


  function sortProducts(collectionId, sortBy) {
      var productsContainer = document.querySelector('.collection-products[data-collection-id="' + collectionId + '"] .main_list');
      var products = Array.from(productsContainer.querySelectorAll('.product-item'));

      products.sort(function(a, b) {
          var productTitleA = a.querySelector('p').innerText.toLowerCase();
          var productTitleB = b.querySelector('p').innerText.toLowerCase();
          var productPriceA = parseFloat(a.getAttribute('data-price'));
          var productPriceB = parseFloat(b.getAttribute('data-price'));
          var productDateA = new Date(a.querySelector('a').getAttribute('href').split('/').pop()); 
          var productDateB = new Date(b.querySelector('a').getAttribute('href').split('/').pop());

          switch (sortBy) {
              case 'a-z':
                  return productTitleA.localeCompare(productTitleB);
              case 'z-a':
                  return productTitleB.localeCompare(productTitleA);
              case 'price-low-high':
                  return productPriceA - productPriceB;
              case 'price-high-low':
                  return productPriceB - productPriceA;
              case 'new-to-old':
                  return productDateB - productDateA;
              case 'old-to-new':
                  return productDateA - productDateB;
              default:
                  return 0; 
          }
      });

      products.forEach(function(product) {
          productsContainer.appendChild(product);
      });
  }




